import { IVR_URLS } from "../../services/apiConfig.js";
import { ASSIGNMENT_ERRORS } from "../../common/constants/ivrModule/assignmentConstants.js";
import apiClient from "../apiInstance.js";

export const getIvrAssignment = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.GET_IVR_JOB);
        const jobs = response.data.policy?.value || [];

        const responseAssignments = jobs
            .map(job => {
                const assignmentEntry = Object.entries(job.assignments || {})[0];
                if (!assignmentEntry) return null;

                const [assignmentId, assignment] = assignmentEntry;

                const assignedDate = assignment?.assignedAt ? new Date(assignment.assignedAt) : null;

                return {
                    id: assignment?.assignmentId || assignmentId || null,
                    jobid: job.id,
                    status: job.status,
                    queue: job.queueId,
                    workerId: assignment?.workerId || null,
                    assignedAtDate: assignedDate,
                };
            })
            .filter(a => a !== null && a.id !== null);

        return responseAssignments;

    } catch (error) {
        console.error(ASSIGNMENT_ERRORS.COMPLETE_ASSIGNMENT_ERROR, error);
        throw error;
    }
};


export const completeIvrAssignment = async ({ assignmentId, workerId, jobId }) => {
    try {
        const response = await apiClient.post(IVR_URLS.COMPLETE_IVR_ASSIGNMENT, {
            assignmentId,
            workerId,
            jobId,
        });
        return response.data;
    } catch (error) {
        console.error(ASSIGNMENT_ERRORS.COMPLETE_ASSIGNMENT_ERROR, error);
        throw error;
    }
};

export const closeIvrAssignment = async ({ assignmentId, workerId, jobId }) => {
    try {
        const response = await apiClient.post(IVR_URLS.CLOSE_IVR_ASSIGNMENT, {
            assignmentId,
            workerId,
            jobId,
        });
        return response.data;
    } catch (error) {
        console.error(ASSIGNMENT_ERRORS.CLOSE_ASSIGNMENT_ERROR, error);
        throw error;
    }
};

export const editIvrAssignment = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.CLOSE_IVR_ASSIGNMENT);
        return response.data;
    } catch (error) {
        console.error(ASSIGNMENT_ERRORS.CLOSE_ASSIGNMENT_ERROR, error);
        throw error;
    }
};

export const addIvrAssignment = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.CLOSE_IVR_ASSIGNMENT);
        return response.data;
    } catch (error) {
        console.error(ASSIGNMENT_ERRORS.CLOSE_ASSIGNMENT_ERROR, error);
        throw error;
    }
};